import { Component, OnInit, Input, Output, EventEmitter, ViewChild, Directive, ViewContainerRef } from '@angular/core';
import { REDEEM, REDEEM_INVESTOR } from '../../../models/redeem';
import { SIMPLE_INVESTOR } from '../../../models/investor';
import { Http, Response, Headers } from '@angular/http';
import { HeaderService } from '../../../header.service';
import { PaginationComponent } from "../../../pagination/pagination.component";
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import * as Globals from '../../../globals';
declare var $: any;

@Component({
  selector: 'app-customredemption-detail',
  templateUrl: './customredemption-detail.component.html',
  styleUrls: ['./customredemption-detail.component.css']
})
export class CustomredemptionDetailComponent implements OnInit {

  param: any;
  @Input() seriesId: number;
  @Input() paramSeries: any;
  @Input() ssId: number;
  @Input() sid: string;
  @Input() invId: number;
  @Input() userProfile: any;
  @Input() authMenu: any;
  @Output() refreshParent = new EventEmitter;
  @ViewChild("fileInput") fileInput: any;
  @ViewChild("redeemAmt") redeemAmtEl: any;
  @ViewChild(PaginationComponent) subchild: PaginationComponent;
  investors: SIMPLE_INVESTOR[];
  redeem: REDEEM;
  redeemInvestor: REDEEM_INVESTOR;
  bids: REDEEM_INVESTOR[];
  redeemBids: any[];
  issuances: any[];
  SID: string;
  INV_NAME: string;
  SERIES_NAME: string;
  BID_CODE: string;
  loading: boolean;
  p:any;
  all: boolean;
  all1: boolean;
  tab_detil: number = 101;
  pagedList: any;
  pagedList2: any;
  pagedNumber: number = 1;
  pageNumber: number = 1;
  pageSize: number = 10;
  sort: string[] = ['BIDDATE'];
  totRedeem: number = 0;
  totKepemilikan: number = 0;
  pcentRedeem: number = 0;
  pcentKepemilikan: number = 0;
  errAmt: boolean;
  search: string;
  editRedeem: boolean;
  selectedBidId: number;
  urlFile = Globals.archiveUrl + 'bids?code=';
  showError: boolean;
  
  pagination: any = [];
  parentPage: number = 0;
  totalParentPage: number = 0;

  constructor(private http: Http, public toastr: ToastsManager, vRef: ViewContainerRef, private headerService: HeaderService) {
    this.toastr.setRootViewContainerRef(vRef);
  }
  ngOnInit() {
    this.investors = [];
    this.redeemBids = [];
    //this.newRedeem();
    //this.redeem = new REDEEM(0, 0, 0, 0, 0, this.userProfile.USER_ID, null, this.userProfile.GROUP_ID);
    //this.paramSeries.MAX_PCENT_ORG = this.paramSeries.MAX_PCENT;
    // this.newRedeemInvestor();
    // if (this.invId > 0) {
      this.getRedeemInvestor(1);
      this.getInvestorBids(1);
    // }
  }
  getInvestor() {
    if (this.search.length > 0) {
      this.loading = true;
      this.http.get(Globals.serviceUrl + 'ritel/redeeminvestor?seriesId=' + this.seriesId + '&search=' + this.search + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          this.investors = res.json();
          this.loading = false;
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
    }
  }
  newRedeem() {
    let fi = this.fileInput.nativeElement;
    fi.value = null;
    //this.redeem = new REDEEM(0, 0, 0, 0, 0, this.userProfile.USER_ID, null, this.userProfile.GROUP_ID);
    var item: any;
    if (this.bids.length > 0) {
      item = this.bids[0];
      this.redeem.REDEMP_ID = item.BID_ID;
    }
    this.redeem.ALT_AMT = item.ALT_AMT;
  }
  // newRedeemInvestor() {
  //   this.redeemInvestor = new REDEEM_INVESTOR(null, null, null, null, null, null, null, null, null, 0, 0, null, null, false, null, null, null, null, null);
  //   this.bids = [];
  // }
  loadParent() {
    this.refreshParent.emit();
  }
  getRedeemInvestor(pageNumber: number) {
    this.loading = true;
    // this.newRedeemInvestor();
    this.all = true;
    this.redeemBids = [];
    this.http.get(Globals.serviceUrl + 'ritel/redeemsonline?seriesId=' + this.seriesId + '&sid=' + this.sid + '&ssId=' + this.ssId + '&pageNumber=' + pageNumber + '&pageSize=' + this.pageSize + '&sort=' + this.sort + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        // this.bids = res.json();
        this.pagedList = res.json();
        this.redeemBids = this.pagedList.Model.Records;
        console.log(this.redeemBids);
        this.pageNumber = pageNumber;
        this.subchild.getPagination(pageNumber, this.pagedList.Model);
        this.totRedeem = this.pagedList.Model.TotalNominal;
        this.totKepemilikan = this.pagedList.Model.TotalBayar;
        this.pcentRedeem = this.totRedeem * 100 / (this.totKepemilikan);
        this.pcentKepemilikan = (this.totKepemilikan - this.totRedeem) * 100 / this.totKepemilikan;
        this.SID = this.redeemBids[0].Sid;
        this.INV_NAME = this.redeemBids[0].InvestorName;
        this.BID_CODE = this.redeemBids[0].BidCode;
        this.SERIES_NAME = this.redeemBids[0].SeriesName;
        // if (this.bids.length == 0) {
        //   this.toastr.warning('Data tidak ditemukan');
        // } else {
        //   this.newRedeem();
        //   for (var i = 0; i < this.bids.length; i++) {
        //     this.redeemInvestor.IDTY_NO = this.bids[i].IDTY_NO;
        //     this.redeemInvestor.INV_NAME = this.bids[i].INV_NAME;
        //     this.redeemInvestor.SERIES_NAME = this.bids[i].SERIES_NAME;
        //     this.redeemInvestor.ALT_AMT += this.bids[i].ALT_AMT;
        //     this.redeemInvestor.REDEEM_AMT += this.bids[i].REDEEM_AMT;
        //   }
        //   this.getRedeemBids();
        // }
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  getInvestorBids(pageNumber: number) {
    this.loading = true;
    //this.pagedList = {};
    this.all1 = true;
    this.issuances = [];
    this.http.get(Globals.serviceUrl + 'ritel/bidsonline?seriesId=' + this.seriesId + '&sid=' + this.sid + '&ssId=' + this.ssId + '&pageNumber=' + pageNumber + '&pageSize=' + this.pageSize + '&sort=' + this.sort + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.pagedList2 = res.json();
        this.issuances = this.pagedList2.Model.Records;
        this.pagedNumber = this.pagedList2.Model.TotalPage;
        // console.log(this.pagedNumber);
        this.pagedNumber = pageNumber;
        this.getPagination(pageNumber, this.pagedList2.Model);
        // this.subchild.getPagination(pageNumber, this.pagedList.Model);
        // this.totBids = this.pagedList.Model.TotalNominal;
        // this.totBayar = this.pagedList.Model.TotalBayar;
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  getPagination(pageNumber: number, pagedList: any) {
    this.pagedNumber = pageNumber;
    this.pagedList = pagedList;
    this.pagination = [];
    this.parentPage = Math.floor((this.pagedNumber - 1) / 5);
    this.totalParentPage = Math.ceil(this.pagedList.TotalPage / 5);
    for (var i = 0; i < 5; i++) {
      var page = i + 1 + (this.parentPage * 5);
      this.pagination.push(page);
      if (page == this.pagedList.TotalPage) {
        break;
      }
    }
  }

  prev() {
    this.pagedNumber = (5 * (this.parentPage - 1)) + 1;
    this.getData(this.pagedNumber);
  }

  next() {
    this.pagedNumber = (5 * (this.parentPage + 1)) + 1;
    this.getData(this.pagedNumber);
  }

  getData(pageNumber: number) {
    this.getInvestorBids(pageNumber);
  }

  deleteRedeem() {
    this.http.delete(Globals.serviceUrl + 'ritel/bids?id=' + this.redeem.BID_ID, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        $('#modal').modal('hide');
        $('#redeem').modal('hide');
        this.toastr.success('Data berhasil dihapus');
        // this.getRedeemInvestor();
        this.loadParent();
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
      });
  }

  checkPcent(val: any) {
    if (isNaN(val) || val == '') {
      this.redeem.REDEEM_AMT = 0;
    } else {
      this.redeem.REDEEM_AMT = (val / 100) * this.redeem.ALT_AMT;
    }
  }

  checkRedeemAmt(val: any) {
    if (isNaN(val) || val == '') {
      this.redeem.PCENT = 0;
      this.redeem.REDEEM_AMT = 0;
    } else {
      this.redeem.PCENT = (val / this.redeem.ALT_AMT) * 100;
    }
  }

  pageChange(pageNumber: number) {
    if (this.all) {
      this.getRedeemInvestor(pageNumber);
    }
    // if (this.all1) {
    //   this.getInvestorBids(pageNumber);
    // }
  }

  pageChange2(pageNumber: number) {
    // if (this.all) {
    //   this.getRedeemInvestor(pageNumber);
    // }
    if (this.all1) {
      this.getInvestorBids(pageNumber);
    }
  } 

  
  generateReport(format: string) {
    this.loading = true;
    this.param = { TICKET_ID: 0, TICKET_VAL: '{seriesId:"' + this.seriesId + '",format:"' + format + '",invId:"' + this.invId + '"}' };
    this.http.post(Globals.serviceUrl + 'ref/ticket', this.param, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.param = res.json();
        var reportUrl = Globals.reportUrl;
        window.open(reportUrl + 'rpt2?id=' + this.param.TICKET_ID, '_blank');
        this.loading = false;
      }, err => {
        this.loading = false;
        this.toastr.error(Globals.errorMessage(err));
        console.log(err);
      });
  }

  onFocus() {
    this.editRedeem = true;
    this.redeemAmtEl.nativeElement.focus();
  }

  getRedeemBids() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/redeembids?invid=' + this.invId + '&seriesId=' + this.seriesId + '&paId=' + this.userProfile.PA_ID + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.redeemBids = [];
        this.redeemBids = res.json();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/ritel-online/custom-redemption/customredemption-detail/customredemption-detail.component.ts